import axiosInstance from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { METHOD_TYPES } from '../../utils/constants/index'

export const getBetsHistoryService = (params) => {
  return axiosInstance(
    METHOD_TYPES.get,
    'fast-games/tower-game/get-bets',
    {},
    {
      server: microServices.SERVICE_URL_1,
      params: params
      // headers: { 'demo-game': isDemoGame }
    }
  )
}

export const placeBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/fast-games/tower-game/place-bet', data, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const openedTileService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/fast-games/tower-game/open-tile', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const cashoutService = () => {
  return axiosInstance(
    METHOD_TYPES.post,
    'fast-games/tower-game/cash-out-bet',
    {},
    {
      server: microServices.SERVICE_URL_1
    }
  )
}

export const getTowerCurrentGameStateService = () => {
  return axiosInstance(
    METHOD_TYPES.get,
    'fast-games/tower-game/get-unfinished-bet-state',
    {},
    {
      server: microServices.SERVICE_URL_1
    }
  )
}
